/* eslint-disable
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./comment.scss');

const deps = [require('data/model/conversation').name, require('data/date').name];

module.exports = angular
  .module('bench.ui.comment', deps)

  .directive('blComment', () => ({
    restrict: 'E',
    scope: {
      conversationId: '@',
      commentIndex: '@',
    },
    bindToController: true,
    template: require('./comment.html'),
    controller: require('./commentCtrl.js'),
    controllerAs: 'vm',
    link(scope, elem, attrs) {
      return scope.$watch('vm.editMode', editMode => {
        if (editMode) {
          const $editInput = elem.find('.edit-input textarea');
          return $editInput.focus();
        }
      });
    },
  }));
